module.exports = __webpack_public_path__ + "img/dial-off.d45ad3dd.svg";